module.exports = __webpack_public_path__ + "static/fonts/OpenSans-Regular.7ce0025.eot";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/fonts/OpenSans-Regular/OpenSans-Regular.eot
// module id = 8pe3
// module chunks = 24